export default "__VITE_ASSET__d02b86a6__"